import { useMutation } from 'react-query';

import { useAuth } from 'modules/authentication/presentation/contexts';
import { makeSendNpsUseCase } from 'shared/domain/useCases';
import { useModal } from 'shared/presentation/components/atoms';
import { useLocale, useToast } from 'shared/presentation/contexts';
import { getBrowserData, getCurrentIp } from 'shared/presentation/helpers';
import { useRequestErrorHandler } from 'shared/presentation/hooks';

import { useSessionFeedback } from '../../../context';

type TValues = {
  evaluation: number;
  comment?: string;
};

const MINIMUM_POSITIVE_EVALUATION = 8;

export default function useNpsSubmission() {
  const { t } = useLocale('shared');
  const modal = useModal();
  const { session, setState } = useSessionFeedback();

  const toast = useToast();
  const { guestId, loggedAsGuest } = useAuth();
  const { handleError } = useRequestErrorHandler('shared');

  const mutation = useMutation(
    async (values: TValues) => {
      const ip = await getCurrentIp();
      const browserData = await getBrowserData();

      return makeSendNpsUseCase().execute({
        ...values,
        customerId: guestId!,
        scheduleHash: session.idHash!,
        sessionType: loggedAsGuest ? 'GUEST' : 'DEFAULT',
        device: {
          ip,
          ...browserData,
        },
      });
    },
    {
      onSuccess: (_, { evaluation }) => {
        toast.success(t('Your feedback was registered Thanks!'));

        if (evaluation >= MINIMUM_POSITIVE_EVALUATION) {
          return setState('RECOMMENDATION');
        }

        return modal.close();
      },
      onError: error => handleError(error),
    },
  );

  return {
    loading: mutation.isLoading,
    submit: mutation.mutateAsync,
  };
}
